import { SBS, CLS, SMC, SEE, QAS, SPR, RES, SES, TTS } from "../constants/routes";
import { ServiceType } from "../types/modelTypes";

// функция для перевода маршрутов
const routeTranslation = (serviceType: ServiceType): string => {
	switch (serviceType) {
		case "smc":
			return SMC;
		case "see":
			return SEE;
		case "spr":
			return SPR;
		case "sbs":
			return SBS;
		case "tts":
			return TTS;
		case "qas":
			return QAS;
		case "ses":
			return SES;
		case "cls":
			return CLS;
		case "res":
			return RES;
		default:
			const defaultServiceType: never = serviceType;
			return defaultServiceType;
	}
};

export default routeTranslation;
